<template>
  <section class="inner-article-container bg-fadeblue">
    <div class="page-container">
      <div class="row g-0 align-items-center mb-5">
          <div class="col-12 col-sm-7">
              <h2 class="heading__h2 bold mb-4 mb-sm-0">Nearest offers</h2>
          </div>
          <div class="col-12 col-sm-5">
              <div class="flex-wrapper shadow">
                  <input type="text" class="form-control px-3 py-4 border-0 fs-5" v-model="zip" maxlength="5" @input="zip = zip.replace(/[^0-9]/g, '')" placeholder="Search by zip-code" aria-label="" aria-describedby="button-addon2">
                  <button @click="getOffersByLocation" type="button" class="icon-search-map m-3"></button>
              </div>
              <div v-if="show_zip_error" style="color:red;padding-top:0.5vw">Please enter valid zip code</div>
              <div v-if="showMapError" style="color:red;padding-top:0.5vw">{{this.showMapError}}</div>
          </div>
      </div>
      <div v-if="nearestOffers && nearestOffers.length" class="row g-0">

        <div class="col-12 col-lg-4 pe-0 pe-lg-5 mb-4 mb-lg-0">
          <featured-vertical-list-component
              :nearestOffers="nearestOffers"
          ></featured-vertical-list-component>
        </div>
        <div class="col-12 col-lg-8">
          <map-component
            :offerLocations="offerLocations"
            :mapCenter="mapCenter"
            :mapId = "dashboard_map_component_id"
          >
          </map-component>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FeaturedVerticalListComponent from "./FeaturedVerticalListComponent.vue";
import MapComponent from "./MapComponent.vue";

export default {
  name: "FeaturedOffersSliderComponent",
  props: ["nearestOffers", "offerLocations", "mapCenter", "showMapError"],
  data() {
      return{
          zip: null,
          show_zip_error: false,
          dashboard_map_component_id: 'dashboard_map_component_id'
      }
  },
  components: {
    MapComponent,
    FeaturedVerticalListComponent,
  },
    methods: {
        getOffersByLocation() {
            this.show_zip_error = false;
            if(isNaN(this.zip) || !this.zip) {
                this.show_zip_error = true;
            } else {
                this.$emit("getOffersByLocation", this.zip);
            }
        },
    },
};
</script>
